import { variables } from '../../common/variables';
import { cl, convertHexToRGBA } from '../../common/functions';

const makeMarkerIcon = (index, type, color, markerType, clusterChildCount) => {
  let html = "";
  let className = "";
  let primaryTypeColor = "";
  let secondaryTypeColor = "";
  let gradient = "";
  if (markerType === "user") {
    // prettier-ignore
    html = /*html*/
      `<div id="leaflet-marker-icon__user" style="--markerColorRGBA:${convertHexToRGBA(color, 0.4)};--markerColor:${color};">
            <svg version="1.1" id="Calque_1" xmlns:serif="http://www.serif.com/" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40"
              width="${variables.markerSize}px" height="${variables.markerSize}px"
              style="enable-background:new 0 0 ${variables.markerSize} ${variables.markerSize};" xml:space="preserve">
              <path fill="${color}" class="st0" d="M20,2.6c-7.2,0-13.3,5.8-13.3,13.3c0,3,2.1,7.4,6,13c3,4,6,7.2,6,7.4l1.2,1.2l1.2-1.2c0.2-0.2,3-3.3,6-7.4 c4.2-5.6,6-10,6-13C33.3,8.4,27.2,2.6,20,2.6z M20,20.5c-2.6,0-4.9-2.1-4.9-4.9s2.1-4.9,4.9-4.9s4.9,2.1,4.9,4.9S22.6,20.5,20,20.5z"/>
            </svg>
            <div class="pulse"></div>
          </div>`;
    className = `user`;
  } else if (markerType === "cluster") {
    if (clusterChildCount) {
      // prettier-ignore
      html = /*html*/
        `<div id="leaflet-marker-icon__${Math.floor(Math.random() * 30) + 1}" style="--markerColor:${color};">
                <svg version="1.1" id="Calque_1" xmlns:serif="http://www.serif.com/"xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 40 40"
                  width="${variables.markerSize}px" height="${variables.markerSize}px"
                  style="enable-background:new 0 0 40 40;" xml:space="preserve">
                  ${gradient}
                  <path fill="${color}" class="st0" d="M33.3,15.2c0-7.4-6-13.3-13.3-13.3S6.7,7.8,6.7,15.2c0,3.7,1.5,7.1,4,9.5c2.5,2.5,4.8,5.8,6.5,8.5S20,38,20,38
                    s1.1-2.1,2.8-4.8c1.7-2.7,4-6.1,6.5-8.5S33.3,18.9,33.3,15.2z M20,20.6c-2.9,0-5.2-2.3-5.2-5.2c0-2.8,2.3-5.2,5.2-5.2
                    s5.2,2.3,5.2,5.2C25.2,18.2,22.9,20.6,20,20.6z"/>
                  <circle cx="20" cy="15.4" r="8.1"/>
                </svg>
                <div class="cluster__child-count">${clusterChildCount}</div>
                <div class="pulse"></div>
            </div>`
      className = `cluster`;
    }
  } else {
    if (index) {
      if (!!color.length) {
        if (color[0] === "") {
          primaryTypeColor = color[1];
          secondaryTypeColor = color[1];
        } else if (color[1] === "") {
          primaryTypeColor = color[0];
          secondaryTypeColor = color[0];
        } else if (color[1] === "" && color[0] === "") {
          primaryTypeColor = variables.primaryColor;
          secondaryTypeColor = variables.primaryColor;
        } else {
          primaryTypeColor = color[0];
          secondaryTypeColor = color[1];
        }
      }
      // prettier-ignore
      html = /*html*/
        `<div id="leaflet-marker-icon__${index + 1}">
              <svg version="1.1" id="Calque_1" xmlns:serif="http://www.serif.com/" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px" y="0px" viewBox="0 0 40 40"
                width="${variables.markerSize}px" height="${variables.markerSize}px"
                style="enable-background:new 0 0 40 40;" xml:space="preserve">
                <defs>
                  <linearGradient id="leaflet-marker-gradient__${index + 1}">
                      <stop offset="0%" stop-color="${primaryTypeColor}"/>
                      <stop offset="100%" stop-color="${secondaryTypeColor}"/>
                  </linearGradient>
                </defs>
                <path fill="url(#leaflet-marker-gradient__${index + 1})" class="st0" d="M20,2.6c-7.2,0-13.3,5.8-13.3,13.3c0,3,2.1,7.4,6,13c3,4,6,7.2,6,7.4l1.2,1.2l1.2-1.2c0.2-0.2,3-3.3,6-7.4 c4.2-5.6,6-10,6-13C33.3,8.4,27.2,2.6,20,2.6z M20,20.5c-2.6,0-4.9-2.1-4.9-4.9s2.1-4.9,4.9-4.9s4.9,2.1,4.9,4.9S22.6,20.5,20,20.5z"/>
              </svg>
              <div class="pulse"></div>
            </div>`;
      className = `${type.join(" ")}`;
    }
  }
  return L.divIcon({
    iconSize: [variables.markerSize, variables.markerSize],
    iconAnchor: [variables.markerSize / 2, variables.markerSize],
    className: className,
    html: html,
    popupAnchor: [0, -variables.markerSize]
  });
}

export { makeMarkerIcon };
